module.exports = __webpack_public_path__ + "static/media/SCBlamp.428380fa.svg";